// Landing Page Configuration - Manual Cejas Radiantes

export const PURCHASE_URL = "https://go.hotmart.com/S104139667W?ap=e66b";

export const PIXEL_ID = "880149501438051"; // Replace with your actual Facebook/Meta Pixel ID

// NOTE: Original Google-hosted images returned 403 Forbidden.
// Replace these URLs with your product images when available.
export const PRODUCT_IMAGES = {
  main: "https://images.pexels.com/photos/5178001/pexels-photo-5178001.jpeg?auto=compress&cs=tinysrgb&w=800",
  secondary: "/images/59d20684-1c7a-46d5-a0dd-923768b0c288.png"
};

export const DECORATIVE_IMAGES = {
  abstract3d1: "https://images.unsplash.com/photo-1635972064135-8ec7711f9895?w=600&q=80",
  abstract3d2: "https://images.unsplash.com/photo-1708909861157-c659653055b8?w=600&q=80",
  cosmetics3d1: "https://images.unsplash.com/photo-1706067002941-a2440392769c?w=600&q=80",
  cosmetics3d2: "https://images.unsplash.com/photo-1706067003154-bf1a01c58bbb?w=600&q=80",
  silk1: "https://images.unsplash.com/photo-1617055407123-3d7130c1f940?w=600&q=80",
  silk2: "https://images.unsplash.com/photo-1770457732756-ef4a8c58b7ae?w=600&q=80"
};

export const MODULES = [
  {
    number: "1",
    title: "Fundamentos que sostienen cada diseño",
    subtitle: "Aquí aprendes a observar con criterio antes de actuar.",
    items: [
      {
        title: "Bioseguridad e higienización",
        description: "El protocolo profesional de bioseguridad e higienización que eleva tu estándar operativo desde el primer contacto."
      },
      {
        title: "Visagismo y análisis de facciones",
        description: "El protocolo estructurado que te permite analizar correctamente el rostro antes de diseñar, evitando decisiones basadas únicamente en intuición."
      },
      {
        title: "Geometría y medidas estándar",
        description: "La aplicación práctica de geometría y proporción para construir inicio, arco y final con coherencia técnica."
      },
      {
        title: "Morfología y tipos de rostro",
        description: "El marco de morfología facial que te permite adaptar el diseño según tipo de rostro sin forzar una forma universal."
      }
    ]
  },
  {
    number: "2",
    title: "Construcción estructural de la ceja",
    subtitle: "Aquí dejas de improvisar forma.",
    items: [
      {
        title: "Estructura de la ceja",
        description: "La estructura técnica completa de la ceja para entender cómo se construye y cómo se equilibra visualmente."
      },
      {
        title: "Medidas estándar",
        description: "La lógica detrás de las medidas estándar para saber cuándo aplicarlas y cuándo ajustarlas según el caso real."
      }
    ]
  },
  {
    number: "3",
    title: "Corrección de casos reales",
    subtitle: "Aquí desarrollas criterio frente a escenarios reales.",
    items: [
      {
        title: "Casos específicos",
        description: "El sistema de corrección para abordar cejas asimétricas, rotas o con crecimiento irregular sin improvisación."
      }
    ]
  },
  {
    number: "4",
    title: "Dominio técnico",
    subtitle: "Aquí tu ejecución se vuelve técnica, no intuitiva.",
    items: [
      {
        title: "Técnicas de depilación: pinza, cera, hilo y más",
        description: "El criterio profesional para seleccionar y aplicar la técnica de depilación adecuada según cada caso."
      },
      {
        title: "Henna",
        description: "El procedimiento detallado para lograr aplicación uniforme y duradera de henna sin manchas ni saturación irregular."
      },
      {
        title: "Grafomotricidad",
        description: "El entrenamiento técnico de precisión manual que mejora control y trazado antes de trabajar sobre la clienta."
      }
    ]
  }
];

export const BONUSES = [
  {
    title: "Plantillas de práctica",
    description: "Guías visuales diseñadas para entrenar tu precisión y ayudarte a consolidar proporciones sin improvisar.",
    tag: "Plantillas descargables"
  },
  {
    title: "Mini curso de automaquillaje",
    description: "Para que comprendas mejor armonía facial y presentación estética, elevando la percepción profesional de tu trabajo.",
    tag: "Mini curso digital"
  },
  {
    title: "Acompañamiento por 2 meses",
    description: "Un espacio directo para enviar prácticas y recibir correcciones mientras desarrollas criterio propio.",
    tag: "Soporte vía WhatsApp"
  },
  {
    title: "Clases de visagismo",
    description: "Profundización técnica en análisis facial aplicada a diseño real, para reforzar el fundamento estructural del manual.",
    tag: "Clases teórico-prácticas"
  }
];
